// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2hzBs","actionsCol":"EnrolledClinics_actionsCol__1FoxQ"};